<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M22.11 21.46L2.39 1.73L1.11 3L6.7 8.59c-.06.14-.13.27-.2.41H3l-1 2h4.06c-.06.33-.06.66-.06 1s0 .67.06 1H3l-1 2h4.5c1.26 3.5 4.58 6 8.5 6c1.21 0 2.36-.26 3.41-.7l2.43 2.43zM8.58 13c-.05-.33-.08-.66-.08-1s.03-.67.08-1h.53l2 2zM15 18.5c-2.5 0-4.68-1.42-5.76-3.5h3.87l3.33 3.33c-.47.1-.94.17-1.44.17M12.2 9H16l-1 2h-.8zm-1.7-1.68L8.74 5.54A8.96 8.96 0 0 1 15 3c2.3 0 4.41.87 6 2.3l-1.77 1.77A6.47 6.47 0 0 0 15 5.5c-1.74 0-3.31.7-4.5 1.82"
        />
    </svg>
</template>
